import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreated = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 67,
	height: 66,
	viewBox: "0 0 67 66",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			width: 66,
			height: 66,
			rx: 33,
			fill: "#2A6DF4",
			fillOpacity: .15
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.2563 26.9395L30.5828 38.6129L24.7461 32.7762",
			stroke: "#2A6DF4",
			strokeWidth: 4.66939,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCreated);
export { ForwardRef as ReactComponent };
